// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Euzla","content":"Consent_content__1zlow","footer":"Consent_footer__oacng"};